/* eslint-disable no-secrets/no-secrets */
import { defineMessages } from 'react-intl';

export default defineMessages({
    clearCategory: {
        id: 'quoteandbind.RecMarLine.templates.MovingTrafficViolations.clearCategory',
        defaultMessage: 'Clear Category'
    },
    industryCodeSearch: {
        id: 'quoteandbind.RecMarLine.templates.MovingTrafficViolations.Violation Category Code Search',
        defaultMessage: 'Violation Category Code Search'
    },
    Code: {
        id: 'quoteandbind.RecMarLine.templates.MovingTrafficViolations.Code',
        defaultMessage: 'Code'
    },
    search: {
        id: 'quoteandbind.RecMarLine.templates.MovingTrafficViolations.Search',
        defaultMessage: 'Search'
    },
    reset: {
        id: 'quoteandbind.RecMarLine.templates.MovingTrafficViolations.Reset',
        defaultMessage: 'Reset'
    },
    cancel: {
        id: 'quoteandbind.RecMarLine.templates.MovingTrafficViolations.Cancel',
        defaultMessage: 'Cancel'
    },
    searchResults: {
        id: 'quoteandbind.RecMarLine.templates.MovingTrafficViolations.Search Results',
        defaultMessage: 'Search Results'
    },
    select: {
        id: 'quoteandbind.RecMarLine.templates.MovingTrafficViolations.Select',
        defaultMessage: 'Select'
    },
    industryCode: {
        id: 'quoteandbind.RecMarLine.templates.MovingTrafficViolations.Violation Category Code',
        defaultMessage: 'Violation Category Code'
    },
    descriptionOfOccupancy: {
        id: 'quoteandbind.RecMarLine.templates.MovingTrafficViolations.Description Of Occupancy',
        defaultMessage: 'Description Of Occupancy'
    },
    selectVioCategory: {
        id: 'quoteandbind.RecMarLine.templates.MovingTrafficViolations.Select Violation Category',
        defaultMessage: 'Select violation {vioDesc}'
    },
     selectedVioCategory: {
        id: 'quoteandbind.RecMarLine.templates.MovingTrafficViolations.Selected Violation Category',
        defaultMessage: '{vioDesc} selected'
    },
});